import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';
import { LocalizedText } from 'bernie-l10n';
import { RouteStore } from 'bernie-core';

import { SearchResultsStore } from 'stores/search-results-store';

import { classNames } from 'uitk-react-utils';
import { UitkLink, UitkLinkTypeSize } from 'uitk-react-link';

import { PlaybackFilterPill } from './playback-filter-pill';

export interface PlaybackFilterProps {
  centerPills?: boolean;
  wrapPills?: boolean;
  searchResults?: SearchResultsStore;
  routeStore?: RouteStore;
  analytics?: any;
  showQuickFilters: boolean;
}

@inject('searchResults', 'routeStore', 'analytics')
@observer
export class PlaybackFilter extends React.Component<PlaybackFilterProps, {}> {
  constructor(props) {
    super(props);
    this.removeAllFilters = this.removeAllFilters.bind(this);
    this.filtersHasLabel = this.filtersHasLabel.bind(this);
  }

  private removeAllFilters(): void {
    const { searchResults, routeStore } = this.props;
    searchResults.clearFilters(routeStore);
  }

  private filtersHasLabel(filters, label): boolean {
    return filters.findIndex(p => p.label === label) > -1;
  }

  public render() {
    const { analytics, routeStore, searchResults, wrapPills, centerPills, showQuickFilters } = this.props;
    const sortAndFilter = searchResults && searchResults.sortAndFilter;
    const isLoading = searchResults && searchResults.isLoading;
    const pills = (sortAndFilter && sortAndFilter.pills) || [];
    const defaults = sortAndFilter && sortAndFilter.defaults;
    const popularFilters =
      (sortAndFilter && sortAndFilter.options && sortAndFilter.options.popularFilter && sortAndFilter.options.popularFilter.options) || [];
    let playbackPills = [];

    const classes = classNames(
      {
        'uitk-scroll-horizontal': !wrapPills,
        'uitk-flex-wrap': wrapPills,
        'uitk-flex-justify-content-center': centerPills,
        'all-l-padding-one': !wrapPills
      },
      'uitk-flex playback-pill-grid'
    );

    pills.forEach(pill => {
      const playbackFilterPill = (
        <PlaybackFilterPill
          key={`playback-filter-${pill.name}-${pill.value}`}
          pill={pill}
          disabled={isLoading}
          routeStore={routeStore}
          defaults={defaults}
          analytics={analytics}
          removable={true}
        />
      );

      if (showQuickFilters) {
        if (!this.filtersHasLabel(popularFilters, pill.label)) {
          playbackPills.push(playbackFilterPill);
        }
      } else {
        playbackPills.push(playbackFilterPill);
      }
    });

    if (showQuickFilters) {
      const checkedPopularFilters = [];
      const uncheckedPopularFilters = [];

      popularFilters.forEach(popularFilter => {
        const pill = {
          name: popularFilter.filterCategory,
          label: popularFilter.label,
          value: popularFilter.value,
          generated: true
        };

        const checked = this.filtersHasLabel(pills, popularFilter.label);
        const playbackFilterPill = (
          <PlaybackFilterPill
            key={`playback-filter-${popularFilter.filterCategory}-${popularFilter.value}`}
            pill={pill}
            disabled={isLoading}
            routeStore={routeStore}
            defaults={defaults}
            analytics={analytics}
            removable={false}
            checked={checked}
          />
        );

        if (checked) {
          checkedPopularFilters.push(playbackFilterPill);
        } else {
          uncheckedPopularFilters.push(playbackFilterPill);
        }
      });

      playbackPills = [...playbackPills, ...checkedPopularFilters, ...uncheckedPopularFilters];
    }

    if (playbackPills.length > 0) {
      return (
        <section className={classes}>
          {playbackPills}
          <AbacusExperiment name="PWA_Remove_all_filters">
            <AbacusControl />
            <AbacusVariant bucket={1}>
              {wrapPills && pills.length > 1 && (
                <div className="all-y-padding-two">
                  <UitkLink
                    type={UitkLinkTypeSize.SMALL}
                    inline={true}
                    onClick={this.removeAllFilters}
                    analytics={
                      analytics && analytics.setupTracker('playback.removeAllFilters', 'Remove all filters applied', analytics.omnitureData)
                    }
                  >
                    <button disabled={isLoading}>
                      <LocalizedText message="hotels.searchResults.playbackFilter.removeAllFilters.linkText" />
                    </button>
                  </UitkLink>
                </div>
              )}
            </AbacusVariant>
          </AbacusExperiment>
        </section>
      );
    }

    return null;
  }
}
